import { assertNever } from 'owa-assert';
import { AttachmentFullViewState } from 'owa-attachment-full-data';
import { ClientAttachmentId } from 'owa-client-ids';
import { SxSReadingPaneMode, getOrCreateSxSStoreData } from 'owa-sxs-store';
import {
    SxSItemReadingPaneState,
    SxSConversationReadingPaneState,
} from '../store/schema/SxSReadingPaneState';
import tryGetAttachmentFullViewStateByIdForConversationView from '../utils/tryGetAttachmentFullViewStateByIdForConversationView';
import tryGetAttachmentFullViewStateByIdForItemView from '../utils/tryGetAttachmentFullViewStateByIdForItemView';

export default function tryGetAttachmentFullViewStateByIdInReadingPane(
    attachmentId: ClientAttachmentId,
    sxsId: string
): AttachmentFullViewState {
    const readingPaneState = getOrCreateSxSStoreData(sxsId).readingPaneState;
    if (readingPaneState) {
        const mode = readingPaneState.mode;
        switch (mode) {
            case SxSReadingPaneMode.ConversationReadingPane:
                const itemId = getOrCreateSxSStoreData(sxsId)?.editState?.itemId
                    ? getOrCreateSxSStoreData(sxsId).editState.itemId
                    : null;
                return tryGetAttachmentFullViewStateByIdForConversationView(
                    (readingPaneState as SxSConversationReadingPaneState).conversationId.Id,
                    attachmentId,
                    itemId
                );
            case SxSReadingPaneMode.ItemReadingPane:
                const sxsItemReadingPaneState = readingPaneState as SxSItemReadingPaneState;
                return tryGetAttachmentFullViewStateByIdForItemView(
                    attachmentId,
                    sxsItemReadingPaneState
                );
            default:
                return assertNever(mode);
        }
    }
    return null;
}
